<template>
  <section class="jsk-block block-interm">
    <div class="container">
      <div class="row text-center">
        <div class="col-12">
          <p class="h3">{{ $t("team.title") }}</p>
          <p>{{ $t("team.subtitle") }}</p>
        </div>
      </div>

      <div class="row mt-5">
        <!-- Diana -->
        <div class="col-12 col-lg-4 col-md-4 col-sm-12 text-center">
          <img src="./../assets/images/team/diana-miron.jpg" class="w-50 team-img">
          <p class="h5 mt-4">{{ $t("team.name[0]") }}</p>
          <p>{{ $t("team.function[0]") }}</p>
        </div>
        
        <!-- Claudia -->
      <div class="col-12 col-lg-4 col-md-4 col-sm-12 text-center">
          <img src="./../assets/images/team/claudia-ifrim.jpg" class="w-50 team-img">
          <p class="h5 mt-4">{{ $t("team.name[1]") }}</p>
          <p>{{ $t("team.function[1]") }}</p>
        </div>

        <!-- Valentin -->
        <div class="col-12 col-lg-4 col-md-4 col-sm-12 text-center">
          <img src="./../assets/images/team/valentin-ionita.jpg" class="w-50 team-img">
          <p class="h5 mt-4">{{ $t("team.name[2]") }}</p>
          <p>{{ $t("team.function[2]") }}</p>
        </div>
      </div>
      <div class="row mt-5">
        <!-- Corneliu -->
        <div class="col-12 col-lg-4 col-md-4 col-sm-12 text-center">
          <img src="./../assets/images/team/corneliu-dumitru.jpeg" class="w-50 team-img">
          <p class="h5 mt-4">{{ $t("team.name[3]") }}</p>
          <p>{{ $t("team.function[3]") }}</p>
        </div>

        <!-- Nicole -->
        <div class="col-12 col-lg-4 col-md-4 col-sm-12 text-center">
          <img src="./../assets/images/team/nicoleta-stan.jpg" class="w-50 team-img">
          <p class="h5 mt-4">{{ $t("team.name[4]") }}</p>
          <p>{{ $t("team.function[4]") }}</p>
        </div>

        <!-- Ligu -->
        <div class="col-12 col-lg-4 col-md-4 col-sm-12 text-center">
          <img src="./../assets/images/team/ligu.jpg" class="w-50 team-img">
          <p class="h5 mt-4">{{ $t("team.name[5]") }}</p>
          <p>{{ $t("team.function[5]") }}</p>
        </div>
      </div>
    </div>
  </section>
</template>


<script>
export default {
  name: "team"
};
</script>